import { WithdrawReportRequest, WithdrawReportResponseWrapper } from "types/withdraw-report";
import { AxiosAPI } from "./axios-service-creator";

export const WithdrawReportService = {
  fetchWithdrawReport: (payload: WithdrawReportRequest) =>
    AxiosAPI.post<WithdrawReportResponseWrapper>("/players/withdraw", payload),
  approve: (id: string) => AxiosAPI.post("/players/withdraw/approve", { withdrawId: id }),
  reject: (id: string) => AxiosAPI.post("/players/withdraw/reject", { withdrawId: id }),
};
